export const mqDesktop = '1280px';
export const mqTabletMin = '720px';
export const mqTabletMax = '1279px';
export const mqMobileMin = '360px';
export const mqMobileMax = '719px';
